var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6209_20362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7366 3.75924L11.0117 0L0.992571 7.87611L0.437143 7.8702V7.87864H0V18H18V7.87864H17.1754L15.5349 3.15618L13.7366 3.75924ZM15.3643 7.87864H6.76886L13.1709 5.73122L14.4754 5.32046L15.3643 7.87864ZM12.0429 4.32773L5.43429 6.5443L10.668 2.42997L12.0429 4.32773ZM1.71429 14.7688V11.1082C2.07591 10.9821 2.40438 10.7782 2.67574 10.5113C2.9471 10.2444 3.15451 9.92131 3.28286 9.56553H14.7171C14.8454 9.92143 15.0528 10.2447 15.3242 10.5117C15.5955 10.7787 15.924 10.9828 16.2857 11.109V14.7696C15.924 14.8958 15.5955 15.0999 15.3242 15.3669C15.0528 15.634 14.8454 15.9572 14.7171 16.3131H3.28457C3.15616 15.9569 2.94854 15.6334 2.67687 15.3662C2.40521 15.099 2.07634 14.8949 1.71429 14.7688Z",
    fill: "#6F9FE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.375C8.30381 9.375 7.63613 9.65156 7.14384 10.1438C6.65156 10.6361 6.375 11.3038 6.375 12C6.375 12.6962 6.65156 13.3639 7.14384 13.8562C7.63613 14.3484 8.30381 14.625 9 14.625C9.69619 14.625 10.3639 14.3484 10.8562 13.8562C11.3484 13.3639 11.625 12.6962 11.625 12C11.625 11.3038 11.3484 10.6361 10.8562 10.1438C10.3639 9.65156 9.69619 9.375 9 9.375ZM7.875 12C7.875 11.7016 7.99353 11.4155 8.2045 11.2045C8.41548 10.9935 8.70163 10.875 9 10.875C9.29837 10.875 9.58452 10.9935 9.7955 11.2045C10.0065 11.4155 10.125 11.7016 10.125 12C10.125 12.2984 10.0065 12.5845 9.7955 12.7955C9.58452 13.0065 9.29837 13.125 9 13.125C8.70163 13.125 8.41548 13.0065 8.2045 12.7955C7.99353 12.5845 7.875 12.2984 7.875 12Z",
    fill: "#6F9FE9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6209_20362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.6f80c612.svg";
export { ForwardRef as ReactComponent };